import './bootstrap';
import './app/toggle-password';
import './app/select-all';
import './app/select-multiple';
import './app/sweetalert2';
import './app/inactivity';
import './app/input-types';
import './app/disable-autocomplete';
import './app/preview-image';
import './app/lockable-products';
import './app/popup';
import './app/tooltips';
import './app/design-system';
import './app/theme-toggle';
import './app/command-palette';

if (document.querySelector('#profile-cropper')) {
    await import('./app/cropper');
}

if (document.querySelector('[data-toggle="table"]')) {
    await import('./app/bootstrap-table/bootstrap-table');
}

if (document.querySelector('[id^="attribute-repeater-"]')) {
    await import('./app/repeater-table');
}

if (document.querySelector('#category-tree')) {
    window.jqTreeReady = import('./app/jqtree');
    await window.jqTreeReady;
}

if (document.querySelector('[data-tagify]')) {
    const { default: Tagify } = await import('@yaireo/tagify');

    window.Tagify = Tagify;
}

window.replaceNotLoadedImagesWithDefault = function (defaultImageUrl = '/img/placeholder.webp') {
    const imgElements = document.querySelectorAll('img');

    imgElements.forEach((img) => {
        img.addEventListener('error', () => {
            img.src = defaultImageUrl;
        });

        if (img && img.getAttribute('loading') != 'lazy') {
            if (!img.complete || img.naturalWidth === 0) {
                img.src = defaultImageUrl;
            }
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    if (window.tinymce && document.querySelector('textarea.input-textarea, .tinymce')) {
        tinymce.init({
            license_key: 'gpl',
            selector: 'textarea.input-textarea, .tinymce',
            plugins: 'lists',
            toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist',
        });
    }

    //Replace not loaded images with default image
    window.replaceNotLoadedImagesWithDefault();

    const initializeTooltip = (element) => {
        element.dataset.tooltip = element.title;
        element.setAttribute('aria-label', element.getAttribute('aria-label') || element.title);
        element.removeAttribute('title');
        element.classList.add('has-tooltip');
    };

    document.querySelectorAll('a[title], button[title]').forEach(initializeTooltip);

    new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (!(node instanceof Element)) {
                    return;
                }

                if (node.matches('a[title], button[title]')) {
                    initializeTooltip(node);
                }

                node.querySelectorAll('a[title], button[title]').forEach(initializeTooltip);
            });
        });
    }).observe(document.body, { childList: true, subtree: true });

    //slug warning on click
    const confirmBtn = document.querySelector('[data-confirm-slug]');
    const declineBtns = document.querySelectorAll('[data-decline-slug]');
    const directInputs = document.querySelectorAll('input[name*="slug"]:not([type="hidden"])');

    directInputs.forEach(function (input) {
        input.dataset.slug = input.value;

        if (input.name.includes('export')) {
            return;
        }

        input.addEventListener('click', function () {
            window.showPopup('slug-warning-popup');

            confirmBtn.dataset.inputname = input.name;

            declineBtns.forEach(function (btn) {

                btn.dataset.inputname = input.name;
            });
        });


        confirmBtn.addEventListener('click', function () {
            const slugInput = document.querySelector('input[name="' + this.dataset.inputname + '"]');
            slugInput.focus();

            window.hidePopup('slug-warning-popup');
        });

        declineBtns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                const slugInput = document.querySelector('input[name="' + this.dataset.inputname + '"]');

                slugInput.value = slugInput.dataset.slug;

                window.hidePopup('slug-warning-popup');
            });
        });
    });
});

